import { useTranslation } from 'react-i18next';

import { Drawer } from 'components/shared';

import AddProjectForm from './AddProjectForm';

type Props = {
  open: boolean;
  handleClose: () => void;
};

export default function AddProjectDrawer({ open, handleClose }: Props) {
  const { t } = useTranslation('common', { keyPrefix: 'activityPlanning' });

  return (
    (<Drawer
      title={t('addProject')}
      anchor="right"
      open={open}
      onClose={handleClose}
    >
      {open && ( // Don't fetch data until drawer is open
        (<AddProjectForm handleClose={handleClose} />)
      )}
    </Drawer>)
  );
}
